import React from "react";
import { cn } from "@/shared/utils";
import InfoIcon from "@/shared/media/icons/CircleInfoProRegular.svg";
import { Button } from "./ui/Button";

export interface FullCoverageDetailsButtonProps {
    onClick: () => void;
    buttonText?: string;
    buttonClass?: string;
    hideIcon?: boolean;
    showFullCoverageDetails?: boolean;
    /** ENG-19040 — gravitas arm: teal, underlined, small label on a 4px-padded transparent button. */
    showDetailsCtaGravitas?: boolean;
}

export default function FullCoverageDetailsButton(props: FullCoverageDetailsButtonProps) {
    const { onClick, buttonText = "Full Coverage Details", buttonClass, hideIcon = false, showFullCoverageDetails, showDetailsCtaGravitas = false } = props;

    return (
        <Button
            onClick={onClick}
            data-testid="full-coverage-details-button"
            className={cn(
                "text-xs text-content-secondary",
                // Padding comes from `p-1` (4px all round) rather than a size preset, and the hover is a
                // colour-only change — the ghost variant's hover fill is dropped so the button stays transparent.
                showDetailsCtaGravitas && "hover:bg-transparent p-1 text-sm text-content-brand-b underline hover:text-content-primary",
                buttonClass
            )}
            variant={showFullCoverageDetails && !showDetailsCtaGravitas ? "outline" : "ghost"}
            startDecorator={!hideIcon && <InfoIcon className="h-4" />}
            decoratorWrapperClass={cn(showDetailsCtaGravitas && "gap-1")}
            size={showDetailsCtaGravitas ? "auto" : "sm"}
        >
            {buttonText}
        </Button>
    );
}
